import { apiClient } from './api/client';

/**
 * Submit a bug report or feature request.
 *
 * Backend route is `POST /api/change-requests` on the NBNA backend. The
 * backend translates to devflow-host /errors and bears the DevFlow token
 * server-side — no DevFlow secret ever ships to the browser.
 */
export async function submitChangeRequest(data) {
  return apiClient.post('/api/change-requests', data);
}
